import { render } from "./DocumentUpdate.vue?vue&type=template&id=0f265ad4"
import script from "./DocumentUpdate.vue?vue&type=script&lang=ts"
export * from "./DocumentUpdate.vue?vue&type=script&lang=ts"

import "./DocumentUpdate.vue?vue&type=style&index=0&id=0f265ad4&lang=scss"
script.render = render

export default script